import Vue from 'vue'
import App from './App.vue'
import AOS from 'aos'
import 'aos/dist/aos.css'
import '@/assets/Global.css';
import Vuetify from 'vuetify'
import vuetify from '@/plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'
import router from './router/index.js'

Vue.config.productionTip = false

Vue.use(Vuetify)

Vue.use(AOS.init())
new Vue({
  router,
  vuetify,
  AOS,
  render: h => h(App),
}).$mount('#app')
